import { api_get, api_post } from "./utils"

const CollaboratorsAPI = {
    load: _loadCollaborators,
    listByIdentity: _loadCollaboratorsList,
    listForCollab: _loadCollaboratorsListForCollab,
    create: _createCollaborators,
};


async function _loadCollaborators(key: string) {
    // Autogenerated
    if (!key) {
        return null;
    }
    return api_get("/collaborators/" + key).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}


async function _loadCollaboratorsList(identityKey: string, variant: string, cursor: string) {
    const url = "/collaborators/list";
    const data = { identity: identityKey, variant, cursor: cursor || ''};
    return api_get(url, data).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}

async function _loadCollaboratorsListForCollab(identity: string, collab: string, cursor: string) {
    let url = `/collaborators/by-collab?identity=${identity}&collab=${collab}`;
    if (cursor) { url += '&cursor=' + cursor; }

    return api_get(url).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}


async function _createCollaborators() {
    // Autogenerated
    return api_post('/collaborators/create',
        {
        })
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        });
}

export default CollaboratorsAPI;
